import { Injectable, Injector, NgZone } from "@angular/core";
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";

@Injectable()
export class GlobalErrorHandler implements HttpInterceptor {
  constructor(
    private zone: NgZone,
    private injector: Injector,
    private toastr: ToastrService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const router: Router = this.injector.get(Router);
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMsg = "";
        if (error.error instanceof ErrorEvent) {
          console.log("This is client side error");
          errorMsg = `Error: ${error.error.message}`;
        } else {
          console.log("This is server side error");
          errorMsg = `Error Code: ${error.status},  Message: ${error.message}`;
        }

        // Erreur HTTP => affichage d'une popup avec le message "user-friendly"
        // Erreur serveur ou erreur de connexion
        if (!navigator.onLine) {
          // Pas de connexion à internet
          this.zone.run(() => this.toastr.warning("No Internet Connection"));
        } else {
          if (router.url !== "/authentication/login" && error.status === 401) {
            // Erreur d'authentification HTTP
            // Déconnexion
            this.zone.run(() => {});
          } else {
            // Erreur HTTP (error.status === 404, 400, 500...)
            // On affiche une alerte à l'utilisateur
            this.zone.run(() => this.toastr.error(error.error.message));
          }
        }
        console.log(errorMsg);
        return throwError(error);
      })
    );
  }
}
